<!-- src/components/CookieConsent/CookieConsentBanner.vue -->
<template>
  <transition name="cookie-banner-fade">
    <div v-if="showBanner" class="cookie-banner">
      <el-row :gutter="20">
        <el-col :xs="24" :sm="24" :md="24" :lg="24">
          <p class="banner-text">
            {{ $t('cookie.bannerExplain') }}
          </p>
        </el-col>
        <el-col :xs="24" :sm="24" :md="24" :lg="24">
          <div class="banner-actions">
            <!-- <el-button size="small" @click="rejectAll">拒绝全部</el-button> -->
            <el-button size="small" type="primary" @click="acceptNecessary">{{ $t('cookie.acceptNecessary') }}</el-button>
            <el-button size="small" type="primary" @click="openPreferences">{{ $t('cookie.openPreferences') }}</el-button>
            <el-button size="small" type="primary" @click="acceptAll">{{ $t('cookie.acceptAll') }}</el-button>
          </div>
        </el-col>
      </el-row>
    </div>
  </transition>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  name: 'CookieConsentBanner',
  
  computed: {
    ...mapState('cookie', ['showBanner'])
  },

  methods: {
    ...mapActions('cookie', [
      'acceptAll',
      'acceptNecessaryOnly',
      'openPreferences'
    ]),

    acceptNecessary() {
      this.acceptNecessaryOnly();
    },

    rejectAll() {
      this.acceptNecessaryOnly();
    }
  }
};
</script>

<style scoped>
.cookie-banner {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: white;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
  z-index: 2000;
  padding: 16px 24px;
  border-top: 1px solid #ebeef5;
}

.banner-text {
  margin: 0 0 16px 0;
  font-size: 14px;
  color: #606266;
  line-height: 1.5;
}

.banner-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  flex-wrap: wrap;
}

@media (max-width: 768px) {
  .banner-actions {
    flex-direction: column;
    align-items: center;
  }
  
  .banner-actions .el-button {
    width: 100%;
    max-width: 200px;
  }
}

/* 自定义过渡动画 - 从下方消失 */
.cookie-banner-fade-enter-active,
.cookie-banner-fade-leave-active {
  transition: all 0.3s ease;
}

.cookie-banner-fade-enter-from {
  opacity: 0;
  transform: translateY(100%);
}

.cookie-banner-fade-leave-to {
  opacity: 0;
  transform: translateY(100%);
}
</style>
